import { Directive, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatInput } from '@angular/material/input';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {

  constructor(
    private matInput?: MatInput,
    private readonly cdr?: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    this.matInput.focus();
    this.cdr.detectChanges();
  }

}
